// 입고 CAPA 모니터링 — «설정» 탭(운영팀 시안 ② · CAPA · 알림 설정).
//   머리줄 = 제목 + [테스트 알림 발송] [변경사항 저장]. 본문 2단(왼쪽 1 1 640px · 오른쪽 1 1 340px — 좁으면 아래로 내린다).
//   왼쪽 ① 센터별 입고 CAPA(기준 유형 PLT|차량 · 일 CAPA · 차량당 PLT · 운영 요일 · 알림 + 요일·기간별 예외 CAPA)
//          = 그 센터 수정 권한(/me centers[].can_edit)이 있을 때만 편집. 없으면 읽기 전용(disabled — 감추지 않는다).
//        ② 알림 규칙 · ③ PLT 환산 기준
//   오른쪽 ④ 알림 채널(메신저 채널 · 초과 시 추가 수신 = 전 센터 공통 + 센터별 센터장) · ⑤ 메시지 미리보기(초과 예시)
//   ②~④ = /me can_manage 일 때만 편집. 맨 아래 조직 지정 = /me can_edit_orgs 일 때만 편집(자기 [조직 저장]).
// 🔴 판정·환산은 여기서 다시 구현하지 않는다 — 값을 그대로 보내고 서버 검증 문구(detail)를 그대로 보인다. 권한도 서버가 막는다.
//    미리보기만 서버 알림 문구(inbound_capa_calc.alert_message)와 같은 모양으로 그린다 — 문구를 바꾸면 둘 다 바꾼다.
// 🔴 [변경사항 저장] = 고칠 수 있는 단위 중 바뀐 행만 PATCH 를 차례로 + (can_manage 면) 바뀐 설정 칸만 모아 PUT 1회.
//    실패한 행은 고치던 값을 남기고 그 행 아래에 서버 문구를 보인다. 판정에 영향을 주는 저장은 서버가 설정 개정값을 바꿔
//    모니터링 [새로고침]이 60초 쿨다운에 걸리지 않고 바로 다시 판정한다 → 성공 문구로 그걸 알린다.
// 🔴 테스트 알림은 «저장된» 받는 곳으로 간다. 받는 곳이 있으면 먼저 묻는다 · 비어 있으면 서버가 보내지 않는다(no_targets).
// 🔴 쓰기는 한 번에 하나(busy) — 늦은 응답이 방금 고친 행을 덮지 않게. 언마운트 뒤에는 setState 하지 않는다.
import { Fragment, useEffect, useRef, useState } from 'react';
import { inboundCapaAPI } from '../../api/client';
import { confirmDialog } from '../../components/AppDialog';
import { kstToday } from '../../utils/kstTime';
import { COLORS, badge, btn, card, input } from '../../utils/uiStyles';
import { dayLabel, errorText } from './MonitorTab';

export const SAVED_REFRESH = '저장했습니다 — 모니터링 [새로고침]에 바로 반영됩니다';
export const NO_TARGETS = '받는 곳이 비어 있어 보내지 않았습니다';
export const HOURLY_NOTE = '매시 판정을 고르면 운영 DB 조회가 하루 24회 일어납니다 — 꼭 필요할 때만 고르세요';
export const VEHICLE_NEEDS_PPV = '차량 기준이면 차량당 PLT 를 넣어야 합니다.';
export const PARTIAL_FAILED = '일부를 저장하지 못했습니다 — 안내가 붙은 행을 확인해 주세요';
// 알림 문구 — 서버 inbound_capa_calc(ALERT_ICONS·ALERT_TITLES·OVER_REQUEST·DETAIL_PREFIX)와 같다.
export const ALERT_ICONS = { over: '🔴', warn: '🟡', release: '🟢' };
export const ALERT_TITLES = { warn: '주의', over: '초과', release: '해제' };
export const OVER_REQUEST = '요청 : 입고 일정 분산 또는 인원·도크 추가 배치 검토 부탁드립니다.';
export const DETAIL_PREFIX = '상세 — 모니터링 화면에서 보기: ';
const ESTIMATED_SUFFIX = ' (추정 포함)';
const UNIT_SUFFIX = { plt: 'PLT', vehicle: '대' };
const SAVED_ORGS = '저장했습니다 — 그 조직 사람이 화면을 다시 열 때부터 적용됩니다';
const NO_CHANGES = '바뀐 항목이 없습니다';
const READONLY_MANAGE = '읽기 전용 — 운영·시스템 관리자 또는 설정 관리 조직만 고칠 수 있습니다';
const READONLY_ORGS = '읽기 전용 — 조직 지정은 운영·시스템 관리자만 할 수 있습니다';
const CONFIRM_TEST = '저장된 받는 곳(채널·전 센터 공통·센터장)에 시험 알림이 실제로 갑니다. 계속할까요?';
const DASH = '—';
const SEARCH_DELAY_MS = 300;
const USER_Q_MAX = 50;
const COMMON = '__common__';                                   // «전 센터 공통» 행의 찾기 대상 키
const WEEKDAYS = ['월', '화', '수', '목', '금', '토', '일'];        // 서버 요일 번호 월=0 … 일=6
const BASIS_OPTIONS = [['plt', 'PLT'], ['vehicle', '차량']];
const MODE_OPTIONS = [
  ['estimate', '기본값으로 추정하고 «추정 포함» 표시'],
  ['exclude', '집계에서 제외하고 별도 목록으로 알림'],
];
const FALLBACK_LABELS = {
  range_mode: { today_6bd: '오늘 포함 6영업일', next_1bd: '익일만', next_10bd: '익일부터 10영업일' },
  schedule: { '1730': '매일 17:30 (17:00 동기화 직후)', '0900_1730': '매일 09:00 · 17:30', hourly: '매시 정각' },
};
const TEST_CODES = { bot_disabled: '메신저 봇이 꺼져 있습니다', send_error: '발송 오류' };
const UNIT_HEADERS = ['센터', '기준 유형', '일 CAPA', '차량당 PLT', '운영 요일', '알림'];
const SETTING_KEYS = [
  'warn_pct', 'over_pct', 'schedule', 'range_mode', 'change_only', 'release_alert', 'reg_types', 'exclude_states',
  'default_boxes_per_plt', 'unregistered_mode', 'channel_id', 'channel_label', 'over_users', 'center_heads',
];
const TARGET_KEYS = ['channel_id', 'channel_label', 'over_users', 'center_heads'];
const NUM_KEYS = ['warn_pct', 'over_pct', 'default_boxes_per_plt'];
const CODE_KEYS = ['reg_types', 'exclude_states'];
const EMPTY_EX = { start_date: '', end_date: '', weekdays: [], capa: '', note: '' };

const section = { ...card, padding: '12px 14px', marginBottom: '12px', overflowWrap: 'anywhere' };
const sectionHead = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px 10px', marginBottom: '8px' };
const sectionTitle = { margin: 0, fontSize: '15px' };
const subTitle = { margin: '0 0 6px', fontSize: '13px' };
const mutedLine = { color: COLORS.textSub, fontSize: '12px' };
const hint = { color: COLORS.textMuted, fontSize: '12px', marginTop: '3px' };
const alertLine = { color: COLORS.dangerText, fontSize: '12px' };
const okLine = { color: COLORS.successText, fontSize: '12px' };
const warnLine = { color: COLORS.warn, background: COLORS.warnSoft, fontSize: '12px', padding: '6px 10px', borderRadius: '6px', marginTop: '8px' };
const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: '10px 12px' };
const labelStyle = { display: 'block', fontSize: '12px', color: COLORS.textSub, marginBottom: '4px' };
const fieldInput = { ...input, padding: '6px 9px', fontSize: '13px' };
const cellInput = { ...input, padding: '4px 6px', fontSize: '13px' };
const inlineRow = { display: 'flex', alignItems: 'center', gap: '6px' };
const th = { padding: '8px', textAlign: 'left', fontSize: '12px', color: COLORS.textSub, whiteSpace: 'nowrap', borderBottom: `2px solid ${COLORS.border}` };
const td = { padding: '6px 8px', fontSize: '13px', borderBottom: `1px solid ${COLORS.borderSoft}`, verticalAlign: 'top' };
const checkItem = { display: 'inline-flex', alignItems: 'center', gap: '3px', marginRight: '6px', fontSize: '13px', whiteSpace: 'nowrap' };
const radioItem = { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', marginTop: '4px' };
const fieldsetStyle = { border: 0, padding: 0, margin: '10px 0 0', minWidth: 0 };
const legendStyle = { ...labelStyle, padding: 0 };
const subBox = { background: COLORS.bg, border: `1px solid ${COLORS.borderSoft}`, padding: '10px 12px', borderRadius: '8px' };
const optList = { marginTop: '6px', border: `1px solid ${COLORS.border}`, borderRadius: '8px', maxHeight: '200px', overflowY: 'auto' };
const optBtn = {
  display: 'block', width: '100%', textAlign: 'left', padding: '6px 10px', fontSize: '13px', background: COLORS.surface,
  border: 0, borderBottom: `1px solid ${COLORS.borderSoft}`, cursor: 'pointer', overflowWrap: 'anywhere',
};
const actions = { display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px', alignItems: 'center' };
const pageHead = { display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '8px 12px', marginBottom: '12px' };
const eyebrow = { color: COLORS.textMuted, fontSize: '12px', marginBottom: '2px' };
const pageTitle = { margin: 0, fontSize: '18px' };
const columns = { display: 'flex', flexWrap: 'wrap', gap: '0 12px', alignItems: 'flex-start' };
const leftCol = { flex: '1 1 640px', minWidth: 0 };
const rightCol = { flex: '1 1 340px', minWidth: 0 };
// 센터별 CAPA 표 — 섹션의 overflowWrap: 'anywhere' 를 물려받으면 표가 열을 글자 하나 폭까지 줄여 'PLT'가 'P / LT'로,
//   '차량'이 '차 / 량'으로 갈린다. 표 안은 낱말 단위로만 줄을 바꾸고(normal · keep-all) 행 칸은 한 줄로 둔다(nowrap)
//   → 표 너비가 모자라면 열을 줄이지 않고 감싼 div(overflowX: auto)가 가로로 스크롤한다.
// 🔴 운영 요일 칸만은 칸 안에서 줄을 바꾼다(요일 하나하나는 한 줄). 요일 7개를 한 줄로 두면 표가 약 810px 이 돼
//   1366px 화면의 왼쪽 칸(약 660px)을 넘고, 맨 끝 «알림» 열이 카드 밖으로 밀려 보이지도 눌리지도 않았다.
//   지금은 약 600px 안에 들어간다(넓은 화면에서는 요일이 다시 한 줄). 센터 칸의 꼬리표도 모자라면 이름 아래로 내린다.
const unitTable = { width: '100%', borderCollapse: 'collapse', minWidth: '560px', overflowWrap: 'normal', wordBreak: 'keep-all' };
const unitTd = { ...td, whiteSpace: 'nowrap' };
const dayTd = { ...td, whiteSpace: 'normal', minWidth: '100px' };
const dayGroup = { display: 'flex', flexWrap: 'wrap', rowGap: '2px' };
const dayItem = { ...checkItem, gap: '2px', marginRight: '4px' };
const dayBox = { margin: 0 };
// 기준 유형 붙은 단추(PLT | 차량) — 글자는 줄바꿈 금지 · 'PLT'·'차량'이 다 들어가는 최소 너비 · 줄어들지 않는다.
const SEG_BTN_MIN = '44px';
const segWrap = { display: 'inline-flex', flexWrap: 'nowrap', whiteSpace: 'nowrap', border: `1px solid ${COLORS.border}`, borderRadius: '6px', overflow: 'hidden' };
const segBtn = (on) => ({
  padding: '4px 10px', fontSize: '12px', border: 0, cursor: 'pointer', lineHeight: '15px',
  whiteSpace: 'nowrap', minWidth: SEG_BTN_MIN, flexShrink: 0, textAlign: 'center',
  background: on ? COLORS.primary : COLORS.surface, color: on ? '#fff' : COLORS.text, fontWeight: on ? 600 : 400,
});
const formulaBox = { background: COLORS.primarySoft, color: COLORS.text, borderRadius: '6px', padding: '8px 10px', fontSize: '13px', fontWeight: 600, marginBottom: '8px' };
const summaryStyle = { cursor: 'pointer', fontSize: '12px', color: COLORS.textSub };
const chip = { ...badge('gray'), gap: '4px', whiteSpace: 'normal' };
const previewCard = { border: `1px solid ${COLORS.border}`, borderLeft: `4px solid ${COLORS.danger}`, borderRadius: '8px', padding: '10px 12px', background: COLORS.surface };
const previewHead = { display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '6px', marginBottom: '6px', fontSize: '12px' };
const previewTitle = { fontWeight: 700, fontSize: '13px' };
const previewLine = { fontSize: '13px', marginTop: '2px' };
const disabledLook = (off) => (off ? { opacity: 0.55, cursor: 'not-allowed' } : {});

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v);
const isNum = (v) => typeof v === 'number' && Number.isFinite(v);
const numText = (v) => (isNum(v) ? String(v) : '');
const fmt = (v) => (isNum(v) ? v.toLocaleString('ko-KR') : DASH);
const fmtInt = (v) => (isNum(v) ? Math.trunc(v).toLocaleString('en-US') : '-');     // 서버 f"{int(v):,}" 와 같다
const sameValue = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const sortDays = (days) => [...new Set((days || []).filter((d) => Number.isInteger(d) && d >= 0 && d <= 6))].sort((a, b) => a - b);
const daysText = (days) => (Array.isArray(days) && days.length ? sortDays(days).map((d) => WEEKDAYS[d]).join('') : '모든 요일');
const uniq = (items) => [...new Set(items)];
const splitCodes = (text) => uniq(String(text || '').split(/[\s,·]+/).map((s) => s.trim()).filter(Boolean));
const splitLines = (text) => uniq(String(text || '').split('\n').map((s) => s.trim()).filter(Boolean));
const personText = (u) => `${u.name || `#${u.id}`}${u.email ? ` · ${u.email}` : ''}`;

// 숫자 칸 — 비우면 null(미설정) · 정수 글자면 숫자 · 그 밖은 글자 그대로 보낸다(범위·형식 판정은 서버 문구로 보인다).
export function toIntOrRaw(value) {
  const s = String(value ?? '').trim().replace(/,/g, '');
  if (s === '') return null;
  return /^-?\d+$/.test(s) ? Number(s) : s;
}

// 가동률 % — 서버 inbound_capa_calc.judge 와 같은 정수 반올림.
export function pctOf(planned, capa) {
  return Math.floor((planned * 200 + capa) / (2 * capa));
}

// 알림 글 1건의 줄 — 서버 inbound_capa_calc.alert_message 와 같은 모양(🔴/🟡/🟢 제목 · 예정 / CAPA · 초과만 요청 · 링크).
export function alertMessageLines({ kind, name, dateIso, planned, capa, pct, basis = 'plt', estimated = false, link = '' }) {
  const unit = UNIT_SUFFIX[basis] || UNIT_SUFFIX.plt;
  const lines = [
    `${ALERT_ICONS[kind]} [입고 CAPA ${ALERT_TITLES[kind]}] ${name} / ${dayLabel(dateIso)}`,
    `예정 / CAPA : ${fmtInt(planned)}${unit} / ${fmtInt(capa)}${unit} (${isNum(pct) ? pct : '-'}%)${estimated ? ESTIMATED_SUFFIX : ''}`,
  ];
  if (kind === 'over') lines.push(OVER_REQUEST);
  lines.push(`${DETAIL_PREFIX}${link}`);
  return lines;
}

// 미리보기 예시 값 — 첫 단위의 CAPA × 1.07 올림(정수 계산 — 100 × 1.07 이 107.000…01 이 되지 않게). CAPA 가 없으면 32 / 30.
export function previewExample(unit) {
  const capa = isNum(unit?.daily_capa) && unit.daily_capa > 0 ? unit.daily_capa : null;
  if (!capa) return { planned: 32, capa: 30 };
  return { planned: Math.floor((capa * 107 + 99) / 100), capa };
}

function draftOf(u) {
  return {
    basis: u.basis || 'plt',
    daily_capa: numText(u.daily_capa),
    plt_per_vehicle: numText(u.plt_per_vehicle),
    weekdays: sortDays(u.weekdays),
    alert_enabled: !!u.alert_enabled,
  };
}

function unitChangesOf(u, d) {
  const changes = {};
  if (d.basis !== (u.basis || 'plt')) changes.basis = d.basis;
  const capa = toIntOrRaw(d.daily_capa);
  if (capa !== (isNum(u.daily_capa) ? u.daily_capa : null)) changes.daily_capa = capa;
  const ppv = toIntOrRaw(d.plt_per_vehicle);
  if (ppv !== (isNum(u.plt_per_vehicle) ? u.plt_per_vehicle : null)) changes.plt_per_vehicle = ppv;
  const days = sortDays(d.weekdays);
  if (!sameValue(days, sortDays(u.weekdays))) changes.weekdays = days;
  if (!!d.alert_enabled !== !!u.alert_enabled) changes.alert_enabled = !!d.alert_enabled;
  return changes;
}

const personOf = (x) => ({ id: x.id, name: x.name || '', email: x.email || '' });

function formOf(s, usersInfo, headsInfo) {
  const info = Array.isArray(usersInfo) ? usersInfo.filter(isObj) : null;
  const ids = Array.isArray(s.over_users) ? s.over_users : [];
  const heads = isObj(s.center_heads) ? s.center_heads : {};
  const hInfo = isObj(headsInfo) ? headsInfo : {};
  return {
    warn_pct: numText(s.warn_pct),
    over_pct: numText(s.over_pct),
    range_mode: s.range_mode || '',
    schedule: s.schedule || '',
    change_only: s.change_only !== false,
    release_alert: !!s.release_alert,
    reg_types: (s.reg_types || []).join(', '),
    exclude_states: (s.exclude_states || []).join(', '),
    unregistered_mode: s.unregistered_mode || 'estimate',
    default_boxes_per_plt: numText(s.default_boxes_per_plt),
    channel_id: s.channel_id || '',
    channel_label: s.channel_label || '',
    over_users: info ? info.map(personOf) : ids.map((id) => ({ id, name: '', email: '' })),
    center_heads: Object.fromEntries(Object.entries(heads).map(([k, list]) => {
      const people = Array.isArray(hInfo[k]) ? hInfo[k].filter(isObj).map(personOf) : null;
      return [k, people || (Array.isArray(list) ? list : []).map((id) => ({ id, name: '', email: '' }))];
    })),
  };
}

// 센터장 {센터: [사람|id]} → {센터: [id]} — 빈 센터는 뺀다(서버도 뺀다). 비교는 키 순서와 무관하게 한다.
const headIds = (heads) => Object.fromEntries(Object.entries(heads || {})
  .map(([k, list]) => [k, (Array.isArray(list) ? list : []).map((u) => (isObj(u) ? u.id : u))])
  .filter(([, list]) => list.length > 0));
const canonHeads = (heads) => JSON.stringify(Object.keys(heads).sort().map((k) => [k, heads[k]]));

function valueOf(form, key) {
  if (NUM_KEYS.includes(key)) return toIntOrRaw(form[key]);
  if (CODE_KEYS.includes(key)) return splitCodes(form[key]);
  if (key === 'over_users') return form.over_users.map((u) => u.id);
  if (key === 'center_heads') return headIds(form.center_heads);
  if (key === 'channel_id' || key === 'channel_label') return String(form[key] || '').trim();
  return form[key];
}

function savedOf(saved, key) {
  const cur = saved?.[key];
  if (key === 'channel_id' || key === 'channel_label') return cur || '';
  if (key === 'over_users') return Array.isArray(cur) ? cur : [];
  if (key === 'center_heads') return headIds(isObj(cur) ? cur : {});
  if (key === 'change_only') return cur !== false;
  return cur;
}

function changesOf(form, saved, keys) {
  const out = {};
  keys.forEach((k) => {
    const v = valueOf(form, k);
    const base = savedOf(saved, k);
    const same = k === 'center_heads' ? canonHeads(v) === canonHeads(base) : sameValue(v, base);
    if (!same) out[k] = v;
  });
  return out;
}

export function testResultText(data) {
  const d = isObj(data) ? data : {};
  if (d.code === 'no_targets') return NO_TARGETS;
  const results = Array.isArray(d.results) ? d.results.filter(isObj) : [];
  const sent = results.filter((x) => x.result === 'sent').length;
  if (d.ok) return `테스트 알림을 보냈습니다 — 받는 곳 ${results.length}곳 중 ${sent}곳`;
  const why = uniq(results.filter((x) => x.result !== 'sent').map((x) => TEST_CODES[x.code] || x.code).filter(Boolean)).join(' · ');
  return `테스트 알림을 보내지 못했습니다${why ? ` — ${why}` : ''}`;
}

function Msg({ msg, testId }) {
  if (!msg) return null;
  const style = msg.kind === 'error' ? alertLine : msg.kind === 'ok' ? okLine : mutedLine;
  return (
    <div data-testid={testId} data-kind={msg.kind} role={msg.kind === 'error' ? 'alert' : 'status'} style={{ ...style, marginTop: '6px' }}>
      {msg.text}
    </div>
  );
}

export default function SettingsTab({ me }) {
  const [units, setUnits] = useState(null);
  const [centers, setCenters] = useState(null);
  const [unitsMsg, setUnitsMsg] = useState('');
  const [drafts, setDrafts] = useState({});
  const [rowMsgs, setRowMsgs] = useState({});
  const [exOpen, setExOpen] = useState(false);
  const [exUnitId, setExUnitId] = useState(null);
  const [exForm, setExForm] = useState(EMPTY_EX);
  const [settingsRes, setSettingsRes] = useState(null);
  const [settingsMsg, setSettingsMsg] = useState('');
  const [form, setForm] = useState(null);
  const [msgs, setMsgs] = useState({});
  const [channels, setChannels] = useState(null);     // null | { enabled, items, error }
  const [search, setSearch] = useState({ target: null, q: '' });
  const [userItems, setUserItems] = useState(null);
  const [userMsg, setUserMsg] = useState('');
  const [orgs, setOrgs] = useState(null);
  const [orgsMsg, setOrgsMsg] = useState('');
  const [orgForm, setOrgForm] = useState({ view: '', manage: '' });
  const [busy, setBusy] = useState('');
  const mountedRef = useRef(true);
  const busyRef = useRef('');
  const timerRef = useRef(null);
  const searchSeqRef = useRef(0);

  const editableKeys = new Set((me?.centers || []).filter((c) => isObj(c) && c.can_edit === true).map((c) => c.center_key));
  const canEditUnit = (u) => !!me && editableKeys.has(u.center_key);
  const canManage = !!me?.can_manage;
  const canEditOrgs = !!me?.can_edit_orgs;
  const manageOff = !canManage || !!busy || !form;
  const orgsOff = !canEditOrgs || !!busy || !orgs;

  const setRowMsg = (id, kind, text) => setRowMsgs((cur) => {
    const next = { ...cur };
    if (kind) next[id] = { kind, text };
    else delete next[id];
    return next;
  });
  const setMsg = (key, kind, text) => setMsgs((cur) => {
    const next = { ...cur };
    if (kind) next[key] = { kind, text };
    else delete next[key];
    return next;
  });

  // 쓰기는 한 번에 하나 — 진행 중이면 누른 것을 버린다.
  const run = async (key, fn) => {
    if (busyRef.current) return;
    busyRef.current = key;
    setBusy(key);
    try {
      await fn();
    } finally {
      busyRef.current = '';
      if (mountedRef.current) setBusy('');
    }
  };

  const loadUnits = async () => {
    try {
      const r = await inboundCapaAPI.units();
      if (!mountedRef.current) return;
      const list = Array.isArray(r?.data?.units) ? r.data.units.filter(isObj) : [];
      setUnits(list);
      setCenters(Array.isArray(r?.data?.centers) ? r.data.centers.filter(isObj) : null);
      setDrafts(Object.fromEntries(list.map((u) => [u.id, draftOf(u)])));
      setUnitsMsg('');
    } catch (err) {
      if (!mountedRef.current) return;
      setUnits((cur) => cur || []);
      setUnitsMsg(errorText(err, '판정 단위를 불러오지 못했습니다.'));
    }
  };

  const loadSettings = async () => {
    try {
      const r = await inboundCapaAPI.settings();
      if (!mountedRef.current) return;
      const data = isObj(r?.data) && isObj(r.data.settings) ? r.data : null;
      if (!data) {
        setSettingsMsg('설정을 불러오지 못했습니다.');
        return;
      }
      setSettingsRes(data);
      setForm(formOf(data.settings, data.over_users_info, data.center_heads_info));
      setSettingsMsg('');
    } catch (err) {
      if (mountedRef.current) setSettingsMsg(errorText(err, '설정을 불러오지 못했습니다.'));
    }
  };

  const loadOrgs = async () => {
    try {
      const r = await inboundCapaAPI.orgs();
      if (!mountedRef.current) return;
      const data = isObj(r?.data) ? r.data : { view_orgs: [], manage_orgs: [] };
      setOrgs(data);
      setOrgForm({ view: (data.view_orgs || []).join('\n'), manage: (data.manage_orgs || []).join('\n') });
      setOrgsMsg('');
    } catch (err) {
      if (!mountedRef.current) return;
      setOrgs((cur) => cur || { view_orgs: [], manage_orgs: [] });
      setOrgsMsg(errorText(err, '조직 지정을 불러오지 못했습니다.'));
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    loadUnits();
    loadSettings();
    loadOrgs();
    return () => {
      mountedRef.current = false;
      clearTimeout(timerRef.current);
      searchSeqRef.current += 1;
    };
  }, []);

  // ── ① CAPA 단위 ──
  const replaceUnit = (row) => {
    setUnits((cur) => (cur || []).map((x) => (x.id === row.id ? { ...x, ...row } : x)));
    setDrafts((cur) => ({ ...cur, [row.id]: draftOf(row) }));
  };
  const setDraft = (id, field, value) => setDrafts((cur) => ({ ...cur, [id]: { ...(cur[id] || {}), [field]: value } }));
  const toggleDay = (id, day, on) => setDrafts((cur) => {
    const d = cur[id] || {};
    const days = (d.weekdays || []).filter((x) => x !== day);
    return { ...cur, [id]: { ...d, weekdays: sortDays(on ? [...days, day] : days) } };
  });

  const addException = (u) => run(`ex-${u.id}`, async () => {
    if (!canEditUnit(u)) return;
    const body = {
      start_date: exForm.start_date,
      end_date: exForm.end_date || exForm.start_date,
      capa: toIntOrRaw(exForm.capa),
    };
    const days = sortDays(exForm.weekdays);
    if (days.length) body.weekdays = days;
    const note = exForm.note.trim();
    if (note) body.note = note;
    setMsg('ex', null);
    try {
      const r = await inboundCapaAPI.addException(u.id, body);
      if (!mountedRef.current) return;
      const ex = isObj(r?.data) ? r.data : null;
      if (ex) setUnits((cur) => (cur || []).map((x) => (x.id === u.id ? { ...x, exceptions: [...(x.exceptions || []), ex] } : x)));
      setExForm(EMPTY_EX);
      setMsg('ex', 'ok', SAVED_REFRESH);
    } catch (err) {
      if (mountedRef.current) setMsg('ex', 'error', errorText(err, '예외 CAPA 를 저장하지 못했습니다.'));
    }
  });

  const deleteException = (u, ex) => run(`exdel-${ex.id}`, async () => {
    if (!canEditUnit(u)) return;
    const ok = await confirmDialog('이 예외 CAPA 를 지웁니다. 계속할까요?');
    if (!ok || !mountedRef.current) return;
    setMsg('ex', null);
    try {
      await inboundCapaAPI.deleteException(u.id, ex.id);
    } catch (err) {
      if (err?.response?.status !== 404) {
        if (mountedRef.current) setMsg('ex', 'error', errorText(err, '예외 CAPA 를 지우지 못했습니다.'));
        return;
      }
    }
    if (!mountedRef.current) return;
    setUnits((cur) => (cur || []).map((x) => (x.id === u.id ? { ...x, exceptions: (x.exceptions || []).filter((e) => e.id !== ex.id) } : x)));
    setMsg('ex', 'ok', SAVED_REFRESH);
  });

  // ── ②~④ 설정 ──
  const setField = (field, value) => setForm((cur) => (cur ? { ...cur, [field]: value } : cur));

  // [변경사항 저장] — 바뀐 단위 행 PATCH(차례로) + 바뀐 설정 칸 PUT 1회.
  const saveAll = () => run('save-all', async () => {
    const pending = [];
    const blocked = [];
    (units || []).forEach((u) => {
      if (!canEditUnit(u)) return;
      const d = drafts[u.id] || draftOf(u);
      const changes = unitChangesOf(u, d);
      if (Object.keys(changes).length === 0) return;
      if (d.basis === 'vehicle' && toIntOrRaw(d.plt_per_vehicle) === null) blocked.push(u.id);
      pending.push([u, changes]);
    });
    if (blocked.length) {
      blocked.forEach((id) => setRowMsg(id, 'error', VEHICLE_NEEDS_PPV));
      setMsg('save', 'error', VEHICLE_NEEDS_PPV);
      return;
    }
    const settingChanges = canManage && form && settingsRes ? changesOf(form, settingsRes.settings, SETTING_KEYS) : {};
    const settingKeys = Object.keys(settingChanges);
    if (pending.length === 0 && settingKeys.length === 0) {
      setMsg('save', 'info', NO_CHANGES);
      return;
    }
    setRowMsgs({});
    setMsg('save', null);
    let unitFailed = 0;
    let settingsError = '';
    for (const [u, changes] of pending) {
      try {
        const r = await inboundCapaAPI.updateUnit(u.id, changes);
        if (!mountedRef.current) return;
        if (isObj(r?.data) && r.data.id === u.id) replaceUnit(r.data);
        setRowMsg(u.id, 'ok', SAVED_REFRESH);
      } catch (err) {
        if (!mountedRef.current) return;
        unitFailed += 1;
        setRowMsg(u.id, 'error', errorText(err, '저장하지 못했습니다.'));      // 고치던 값(초안)은 남긴다
      }
    }
    if (settingKeys.length) {
      try {
        const r = await inboundCapaAPI.putSettings(settingChanges);
        if (!mountedRef.current) return;
        const data = isObj(r?.data) && isObj(r.data.settings) ? r.data : null;
        if (data) {
          setSettingsRes(data);
          const fresh = formOf(data.settings, data.over_users_info, data.center_heads_info);
          // 저장한 칸만 서버 값으로 다시 채운다 — 다른 칸에 고치던 값은 남긴다.
          setForm((cur) => {
            const next = { ...(cur || fresh) };
            settingKeys.forEach((k) => { next[k] = fresh[k]; });
            return next;
          });
        }
      } catch (err) {
        if (!mountedRef.current) return;
        settingsError = errorText(err, '설정을 저장하지 못했습니다.');
      }
    }
    if (settingsError) setMsg('save', 'error', settingsError);
    else if (unitFailed) setMsg('save', 'error', PARTIAL_FAILED);
    else setMsg('save', 'ok', SAVED_REFRESH);
  });

  const loadChannels = async () => {
    if (!canManage) return;
    try {
      const r = await inboundCapaAPI.notifyChannels();
      if (!mountedRef.current) return;
      const data = isObj(r?.data) ? r.data : {};
      const items = Array.isArray(data.items) ? data.items.filter(isObj) : [];
      setChannels(data.enabled === false
        ? { enabled: false, items: [], error: '메신저 봇이 연결되어 있지 않아 채널을 고를 수 없습니다' }
        : { enabled: true, items, error: '' });
    } catch (err) {
      if (mountedRef.current) setChannels({ enabled: false, items: [], error: errorText(err, '채널 목록을 불러오지 못했습니다.') });
    }
  };

  const pickChannel = (id) => {
    const item = (channels?.items || []).find((c) => c.id === id);
    if (!item) return;
    setForm((cur) => (cur ? { ...cur, channel_id: item.id, channel_label: item.name || '' } : cur));
  };

  const clearChannel = () => setForm((cur) => (cur ? { ...cur, channel_id: '', channel_label: '' } : cur));

  const stopSearch = () => {
    clearTimeout(timerRef.current);
    timerRef.current = null;
    searchSeqRef.current += 1;
    setUserItems(null);
    setUserMsg('');
  };

  // 사람 찾기 — 한 번에 한 행(전 센터 공통 또는 센터 하나)만 찾는다.
  const onUserQ = (target, value) => {
    if (!canManage) return;
    stopSearch();
    setSearch({ target, q: value });
    const q = value.trim();
    if (!q || q.length > USER_Q_MAX) return;
    const seq = searchSeqRef.current;
    timerRef.current = setTimeout(async () => {
      timerRef.current = null;
      try {
        const r = await inboundCapaAPI.notifyUsers(q);
        if (!mountedRef.current || seq !== searchSeqRef.current) return;
        setUserItems(Array.isArray(r?.data?.items) ? r.data.items.filter(isObj) : []);
        setUserMsg('');
      } catch (err) {
        if (!mountedRef.current || seq !== searchSeqRef.current) return;
        setUserItems(null);
        setUserMsg(errorText(err, '사람을 찾지 못했습니다.'));
      }
    }, SEARCH_DELAY_MS);
  };

  const addPerson = (target, u) => {
    if (!canManage) return;
    stopSearch();
    setSearch({ target: null, q: '' });
    const person = { id: u.id, name: u.name || u.email || String(u.id), email: u.email || '' };
    setForm((cur) => {
      if (!cur) return cur;
      if (target === COMMON) {
        return cur.over_users.some((x) => x.id === u.id) ? cur : { ...cur, over_users: [...cur.over_users, person] };
      }
      const list = cur.center_heads[target] || [];
      if (list.some((x) => x.id === u.id)) return cur;
      return { ...cur, center_heads: { ...cur.center_heads, [target]: [...list, person] } };
    });
  };

  const removePerson = (target, id) => setForm((cur) => {
    if (!cur) return cur;
    if (target === COMMON) return { ...cur, over_users: cur.over_users.filter((x) => x.id !== id) };
    return { ...cur, center_heads: { ...cur.center_heads, [target]: (cur.center_heads[target] || []).filter((x) => x.id !== id) } };
  });

  const sendTest = () => run('test', async () => {
    if (!canManage) return;
    setMsg('test', null);
    const s = settingsRes?.settings || {};
    const heads = isObj(s.center_heads) ? s.center_heads : {};
    const hasTargets = !!String(s.channel_id || '').trim()
      || (Array.isArray(s.over_users) && s.over_users.length > 0)
      || Object.values(heads).some((ids) => Array.isArray(ids) && ids.length > 0);
    if (hasTargets) {
      const ok = await confirmDialog(CONFIRM_TEST);
      if (!ok || !mountedRef.current) return;
    }
    try {
      const r = await inboundCapaAPI.notifyTest();
      if (!mountedRef.current) return;
      const d = isObj(r?.data) ? r.data : {};
      setMsg('test', d.ok ? 'ok' : d.code === 'no_targets' ? 'info' : 'error', testResultText(d));
    } catch (err) {
      if (mountedRef.current) setMsg('test', 'error', errorText(err, '테스트 알림을 보내지 못했습니다.'));
    }
  });

  // ── 조직 ──
  const saveOrgs = () => run('orgs', async () => {
    if (!canEditOrgs || !orgs) return;
    const view = splitLines(orgForm.view);
    const manage = splitLines(orgForm.manage);
    const body = {};
    if (!sameValue(view, orgs.view_orgs || [])) body.view_orgs = view;
    if (!sameValue(manage, orgs.manage_orgs || [])) body.manage_orgs = manage;
    if (Object.keys(body).length === 0) {
      setMsg('orgs', 'info', NO_CHANGES);
      return;
    }
    setMsg('orgs', null);
    try {
      const r = await inboundCapaAPI.putOrgs(body);
      if (!mountedRef.current) return;
      if (isObj(r?.data)) {
        setOrgs(r.data);
        setOrgForm({ view: (r.data.view_orgs || []).join('\n'), manage: (r.data.manage_orgs || []).join('\n') });
      }
      setMsg('orgs', 'ok', SAVED_ORGS);
    } catch (err) {
      if (mountedRef.current) setMsg('orgs', 'error', errorText(err, '조직 지정을 저장하지 못했습니다.'));
    }
  });

  // ── 그리기 ──
  const centerList = (centers || me?.centers || []).filter(isObj);
  const centerOf = (key) => centerList.find((c) => c.center_key === key) || null;
  const centerName = (key) => centerOf(key)?.display_name || key;
  const perCenter = {};
  (units || []).forEach((u) => { perCenter[u.center_key] = (perCenter[u.center_key] || 0) + 1; });
  const unitLabel = (u) => {
    const name = u.center_name || centerName(u.center_key);
    return (perCenter[u.center_key] || 0) > 1 ? `${name} · ${u.name}` : name;
  };

  const renderExceptions = (u, editable) => {
    const off = !editable || !!busy;
    const list = u.exceptions || [];
    const base = `ic-ex-${u.id}`;
    return (
      <div data-testid="ic-set-ex-panel" data-unit-id={u.id} style={subBox}>
        <h4 style={subTitle}>예외 CAPA — {unitLabel(u)}</h4>
        <div style={{ ...mutedLine, marginBottom: '6px' }}>그 기간(적용 요일)에는 일 CAPA 대신 이 값으로 판정합니다</div>
        {!editable && <div style={{ ...mutedLine, marginBottom: '6px' }}>읽기 전용 — 이 센터의 예외 CAPA 는 볼 수만 있습니다</div>}
        {list.length === 0 && <div style={mutedLine}>등록된 예외가 없습니다</div>}
        {list.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table aria-label="예외 CAPA 목록" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '520px' }}>
              <thead><tr>{['기간', '적용 요일', 'CAPA', '사유', '수정자', '동작'].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {list.map((ex) => (
                  <tr key={ex.id} data-testid="ic-set-ex-item" data-ex-id={ex.id}>
                    <td style={td}>{ex.start_date === ex.end_date ? ex.start_date : `${ex.start_date} ~ ${ex.end_date}`}</td>
                    <td style={td}>{daysText(ex.weekdays)}</td>
                    <td style={td}>{fmt(ex.capa)}</td>
                    <td style={td}>{ex.note || DASH}</td>
                    <td style={td}>{ex.updater_name || DASH}</td>
                    <td style={td}>
                      <button type="button" onClick={() => deleteException(u, ex)} disabled={off}
                        style={{ ...btn('danger', 'sm'), ...disabledLook(off) }}>삭제</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ ...grid, marginTop: '10px' }}>
          <div style={{ minWidth: 0 }}>
            <label htmlFor={`${base}-start`} style={labelStyle}>시작일</label>
            <input id={`${base}-start`} type="date" value={exForm.start_date} disabled={off}
              onChange={(ev) => setExForm((cur) => ({ ...cur, start_date: ev.target.value }))} style={{ ...fieldInput, ...disabledLook(off) }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <label htmlFor={`${base}-end`} style={labelStyle}>종료일(비우면 시작일 하루)</label>
            <input id={`${base}-end`} type="date" value={exForm.end_date} disabled={off}
              onChange={(ev) => setExForm((cur) => ({ ...cur, end_date: ev.target.value }))} style={{ ...fieldInput, ...disabledLook(off) }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <label htmlFor={`${base}-capa`} style={labelStyle}>예외 CAPA</label>
            <input id={`${base}-capa`} type="text" inputMode="numeric" value={exForm.capa} disabled={off}
              onChange={(ev) => setExForm((cur) => ({ ...cur, capa: ev.target.value }))} style={{ ...fieldInput, ...disabledLook(off) }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <label htmlFor={`${base}-note`} style={labelStyle}>사유(선택)</label>
            <input id={`${base}-note`} type="text" maxLength={200} value={exForm.note} disabled={off}
              onChange={(ev) => setExForm((cur) => ({ ...cur, note: ev.target.value }))} style={{ ...fieldInput, ...disabledLook(off) }} />
          </div>
        </div>
        <fieldset style={fieldsetStyle}>
          <legend style={legendStyle}>적용 요일(비우면 모든 요일)</legend>
          {WEEKDAYS.map((w, i) => (
            <label key={w} style={checkItem}>
              <input type="checkbox" checked={exForm.weekdays.includes(i)} disabled={off}
                onChange={(ev) => setExForm((cur) => ({
                  ...cur, weekdays: sortDays(ev.target.checked ? [...cur.weekdays, i] : cur.weekdays.filter((x) => x !== i)),
                }))} />
              {w}
            </label>
          ))}
        </fieldset>
        <div style={actions}>
          <button type="button" onClick={() => addException(u)} disabled={off}
            style={{ ...btn('primary', 'sm'), ...disabledLook(off) }}>예외 추가</button>
        </div>
        <Msg msg={msgs.ex} testId="ic-set-ex-msg" />
      </div>
    );
  };

  const renderUnit = (u) => {
    const editable = canEditUnit(u);
    const off = !editable || !!busy;
    const d = drafts[u.id] || draftOf(u);
    const temp = centerOf(u.center_key)?.temp_zone || u.temp_label || '';
    const vehicle = d.basis === 'vehicle';
    const ppvOff = off || !vehicle;
    return (
      <Fragment key={u.id}>
        <tr data-testid="ic-set-unit-row" data-unit-id={u.id} data-editable={editable ? 'true' : 'false'}>
          <td data-testid="ic-set-unit-center" style={{ ...unitTd, minWidth: '96px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2px 4px' }}>
              <b style={{ whiteSpace: 'nowrap' }}>{u.center_name || centerName(u.center_key)}</b>
              {temp && <span data-testid="ic-set-unit-temp" style={badge('gray')}>{temp}</span>}
              {!editable && <span style={badge('gray')}>읽기 전용</span>}
            </div>
            {(perCenter[u.center_key] || 0) > 1 && <div data-testid="ic-set-unit-name" style={mutedLine}>{u.name}</div>}
          </td>
          <td data-testid="ic-set-unit-basis" style={{ ...unitTd, minWidth: '92px' }}>
            <div role="group" aria-label="기준 유형" style={segWrap}>
              {BASIS_OPTIONS.map(([value, text]) => {
                const on = d.basis === value;
                return (
                  <button key={value} type="button" aria-pressed={on} disabled={off} onClick={() => setDraft(u.id, 'basis', value)}
                    style={{ ...segBtn(on), ...disabledLook(off) }}>{text}</button>
                );
              })}
            </div>
          </td>
          <td style={unitTd}>
            <input aria-label="일 CAPA" type="text" inputMode="numeric" placeholder="미설정" value={d.daily_capa} disabled={off}
              onChange={(ev) => setDraft(u.id, 'daily_capa', ev.target.value)} style={{ ...cellInput, width: '64px', ...disabledLook(off) }} />
            <span style={{ ...mutedLine, marginLeft: '4px' }}>{vehicle ? '대' : 'PLT'}</span>
          </td>
          <td style={unitTd}>
            <input aria-label="차량당 PLT" type="text" inputMode="numeric" placeholder={vehicle ? '필수' : DASH}
              aria-required={vehicle} value={vehicle ? d.plt_per_vehicle : ''} disabled={ppvOff}
              onChange={(ev) => setDraft(u.id, 'plt_per_vehicle', ev.target.value)}
              style={{ ...cellInput, width: '56px', ...(vehicle ? {} : { background: COLORS.borderSoft, color: COLORS.textMuted }), ...disabledLook(ppvOff) }} />
          </td>
          <td data-testid="ic-set-unit-days" style={dayTd}>
            <div role="group" aria-label="운영 요일" style={dayGroup}>
              {WEEKDAYS.map((w, i) => (
                <label key={w} style={dayItem}>
                  <input type="checkbox" checked={(d.weekdays || []).includes(i)} disabled={off}
                    onChange={(ev) => toggleDay(u.id, i, ev.target.checked)} style={dayBox} />
                  {w}
                </label>
              ))}
            </div>
          </td>
          <td data-testid="ic-set-unit-alert" style={unitTd}>
            <button type="button" aria-label="알림" aria-pressed={!!d.alert_enabled} disabled={off}
              onClick={() => setDraft(u.id, 'alert_enabled', !d.alert_enabled)}
              style={{ ...badge(d.alert_enabled ? 'success' : 'gray'), border: 0, cursor: 'pointer', ...disabledLook(off) }}>
              {d.alert_enabled ? '사용' : '끔'}
            </button>
          </td>
        </tr>
        {rowMsgs[u.id] && (
          <tr><td colSpan={UNIT_HEADERS.length} style={td}><Msg msg={rowMsgs[u.id]} testId="ic-set-unit-msg" /></td></tr>
        )}
      </Fragment>
    );
  };

  const renderSearch = (target, label) => {
    const active = search.target === target;
    return (
      <div style={{ minWidth: '120px' }}>
        <input aria-label={label} type="text" autoComplete="off" placeholder="이름·메일" value={active ? search.q : ''}
          disabled={manageOff} onChange={(ev) => onUserQ(target, ev.target.value)} style={{ ...cellInput, ...disabledLook(manageOff) }} />
        {active && userMsg && <div style={{ ...alertLine, marginTop: '4px' }}>{userMsg}</div>}
        {active && userItems && userItems.length === 0 && <div style={{ ...mutedLine, marginTop: '4px' }}>찾은 사람이 없습니다</div>}
        {active && userItems && userItems.length > 0 && (
          <div style={optList}>
            {userItems.map((u) => (
              <button key={u.id} type="button" data-testid="ic-set-user-opt" data-user-id={u.id} onClick={() => addPerson(target, u)}
                disabled={manageOff} style={{ ...optBtn, ...disabledLook(manageOff) }}>
                {`${u.name || DASH}${u.email ? ` · ${u.email}` : ''}`}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderPeople = (target, people, testId, removeLabel) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {people.length === 0 && <span style={mutedLine}>없음</span>}
      {people.map((u) => (
        <span key={u.id} data-testid={testId} data-user-id={u.id} style={chip}>
          {personText(u)}
          <button type="button" aria-label={removeLabel(u)} onClick={() => removePerson(target, u.id)} disabled={manageOff}
            style={{ ...btn('icon', 'sm'), width: '18px', height: '18px', ...disabledLook(manageOff) }}>✕</button>
        </span>
      ))}
    </div>
  );

  const labels = {
    range_mode: settingsRes?.labels?.range_mode || FALLBACK_LABELS.range_mode,
    schedule: settingsRes?.labels?.schedule || FALLBACK_LABELS.schedule,
  };
  const isHourly = (key) => /hourly|every_hour/i.test(String(key || '')) || /매시/.test(String(labels.schedule[key] || ''));
  const saved = settingsRes?.settings || {};
  const targetsDirty = !!form && Object.keys(changesOf(form, saved, TARGET_KEYS)).length > 0;
  const readOnlyManage = !canManage && <div data-testid="ic-set-readonly" style={mutedLine}>{READONLY_MANAGE}</div>;
  const saveOff = !!busy || !(canManage || (units || []).some(canEditUnit));
  const testOff = !canManage || !!busy || !form;
  const exUnit = (units || []).find((u) => u.id === exUnitId) || (units || [])[0] || null;
  // 센터장 표 = 보이는 센터 + (저장돼 있지만 지금 목록에 없는 센터 — 지울 수 있게)
  const headCenters = [
    ...centerList.map((c) => ({ key: c.center_key, label: c.display_name || c.center_key })),
    ...Object.keys(form?.center_heads || {}).filter((k) => !centerList.some((c) => c.center_key === k)).map((k) => ({ key: k, label: k })),
  ];
  // 미리보기(초과 예시) — 첫 단위 · 오늘 날짜 · 서버 문구와 같은 모양
  const first = (units || [])[0] || null;
  const example = previewExample(first);
  const today = kstToday();
  const previewLines = alertMessageLines({
    kind: 'over', name: first?.name || '평택센터', dateIso: today, planned: example.planned, capa: example.capa,
    pct: pctOf(example.planned, example.capa), basis: first?.basis || 'plt',
    link: `${window.location.origin}/inbound-capa?date=${today}${first ? `&unit=${first.id}` : ''}`,
  });
  const warnText = form?.warn_pct || numText(saved.warn_pct) || '90';

  return (
    <>
      <div style={pageHead}>
        <div style={{ minWidth: 0 }}>
          <div style={eyebrow}>입고 CAPA 모니터링</div>
          <h2 style={pageTitle}>CAPA · 알림 설정</h2>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          <button type="button" data-testid="ic-set-test" onClick={sendTest} disabled={testOff}
            style={{ ...btn('secondary'), ...disabledLook(testOff) }}>테스트 알림 발송</button>
          <button type="button" data-testid="ic-set-save-all" onClick={saveAll} disabled={saveOff}
            style={{ ...btn('primary'), ...disabledLook(saveOff) }}>변경사항 저장</button>
        </div>
      </div>
      <div style={{ marginBottom: '8px' }}>
        <Msg msg={msgs.save} testId="ic-set-save-msg" />
        <Msg msg={msgs.test} testId="ic-set-test-result" />
      </div>

      <div style={columns}>
        <div style={leftCol}>
          <section data-testid="ic-set-units" aria-labelledby="ic-set-units-title" style={section}>
            <div style={sectionHead}>
              <h3 id="ic-set-units-title" style={sectionTitle}>센터별 입고 CAPA</h3>
              <span style={mutedLine}>하루 기준 · 센터마다 PLT 또는 차량대수 중 하나로 관리</span>
            </div>
            {unitsMsg && <div role="alert" style={alertLine}>{unitsMsg}</div>}
            {units === null && <div role="status" style={mutedLine}>불러오는 중…</div>}
            {units !== null && (
              <div style={{ overflowX: 'auto' }}>
                <table aria-label="센터별 입고 CAPA" style={unitTable}>
                  <thead><tr>{UNIT_HEADERS.map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {units.map(renderUnit)}
                    {units.length === 0 && (
                      <tr><td colSpan={UNIT_HEADERS.length} style={{ ...td, textAlign: 'center', color: COLORS.textMuted }}>볼 수 있는 판정 단위가 없습니다</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ ...mutedLine, marginTop: '6px' }}>일 CAPA 를 비우면 «CAPA 미설정» · 운영 요일이 아닌 날은 판정하지 않습니다 · 고칠 수 있는 센터만 편집됩니다</div>
            {units !== null && units.length > 0 && (
              <>
                <div style={actions}>
                  <button type="button" aria-expanded={exOpen} onClick={() => setExOpen((v) => !v)} style={btn('secondary', 'sm')}>
                    + 요일·기간별 예외 CAPA 추가
                  </button>
                </div>
                {exOpen && exUnit && (
                  <div data-testid="ic-set-ex-box" style={{ marginTop: '8px' }}>
                    <div style={{ maxWidth: '320px', marginBottom: '8px' }}>
                      <label htmlFor="ic-set-ex-unit" style={labelStyle}>예외를 넣을 센터</label>
                      <select id="ic-set-ex-unit" value={String(exUnit.id)}
                        onChange={(ev) => { setExUnitId(Number(ev.target.value)); setExForm(EMPTY_EX); setMsg('ex', null); }}
                        style={fieldInput}>
                        {units.map((u) => <option key={u.id} value={String(u.id)}>{`${unitLabel(u)} (${(u.exceptions || []).length})`}</option>)}
                      </select>
                    </div>
                    {renderExceptions(exUnit, canEditUnit(exUnit))}
                  </div>
                )}
              </>
            )}
          </section>

          {settingsMsg && <div role="alert" style={{ ...section, ...alertLine }}>{settingsMsg}</div>}
          {!form && !settingsMsg && <div role="status" style={{ ...section, ...mutedLine }}>설정을 불러오는 중…</div>}
          {form && (
            <>
              <section data-testid="ic-set-rules" aria-labelledby="ic-set-rules-title" style={section}>
                <div style={sectionHead}>
                  <h3 id="ic-set-rules-title" style={sectionTitle}>알림 규칙</h3>
                  {readOnlyManage}
                </div>
                <div style={grid}>
                  <div style={{ minWidth: 0 }}>
                    <label htmlFor="ic-set-warn" style={labelStyle}>주의 기준(%)</label>
                    <div style={inlineRow}>
                      <input id="ic-set-warn" type="text" inputMode="numeric" value={form.warn_pct} disabled={manageOff}
                        aria-describedby="ic-set-warn-hint" onChange={(ev) => setField('warn_pct', ev.target.value)}
                        style={{ ...fieldInput, width: '90px', ...disabledLook(manageOff) }} />
                      <span style={mutedLine}>% 이상</span>
                    </div>
                    <div id="ic-set-warn-hint" style={hint}>예정 ÷ CAPA가 이 값을 넘으면 주의 알림</div>
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <label htmlFor="ic-set-over" style={labelStyle}>초과 기준(%)</label>
                    <div style={inlineRow}>
                      <input id="ic-set-over" type="text" inputMode="numeric" value={form.over_pct} disabled={manageOff}
                        aria-describedby="ic-set-over-hint" onChange={(ev) => setField('over_pct', ev.target.value)}
                        style={{ ...fieldInput, width: '90px', ...disabledLook(manageOff) }} />
                      <span style={mutedLine}>% 이상</span>
                    </div>
                    <div id="ic-set-over-hint" style={hint}>초과 알림은 센터장까지 함께 수신</div>
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <label htmlFor="ic-set-schedule" style={labelStyle}>판정 시각</label>
                    <select id="ic-set-schedule" value={form.schedule} disabled={manageOff}
                      onChange={(ev) => setField('schedule', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }}>
                      {Object.entries(labels.schedule).map(([value, text]) => <option key={value} value={value}>{text}</option>)}
                    </select>
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <label htmlFor="ic-set-range" style={labelStyle}>판정 범위</label>
                    <select id="ic-set-range" value={form.range_mode} disabled={manageOff}
                      onChange={(ev) => setField('range_mode', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }}>
                      {Object.entries(labels.range_mode).map(([value, text]) => <option key={value} value={value}>{text}</option>)}
                    </select>
                  </div>
                </div>
                {isHourly(form.schedule) && <div data-testid="ic-set-hourly-note" role="status" style={warnLine}>{HOURLY_NOTE}</div>}
                <div style={{ marginTop: '10px', display: 'grid', gap: '8px' }}>
                  <div>
                    <label style={checkItem}>
                      <input id="ic-set-change-only" type="checkbox" checked={form.change_only} disabled={manageOff}
                        aria-describedby="ic-set-change-only-hint" onChange={(ev) => setField('change_only', ev.target.checked)} />
                      단계가 바뀔 때만 다시 알림
                    </label>
                    <div id="ic-set-change-only-hint" style={hint}>같은 센터·날짜가 계속 주의 상태면 반복 발송하지 않습니다</div>
                  </div>
                  <div>
                    <label style={checkItem}>
                      <input id="ic-set-release" type="checkbox" checked={form.release_alert} disabled={manageOff}
                        aria-describedby="ic-set-release-hint" onChange={(ev) => setField('release_alert', ev.target.checked)} />
                      정상으로 돌아오면 해제 알림
                    </label>
                    <div id="ic-set-release-hint" data-testid="ic-set-release-hint" style={hint}>
                      {`요청 취소·일정 변경으로 ${warnText}% 아래로 내려간 경우`}
                    </div>
                  </div>
                </div>
                <details data-testid="ic-set-query" style={{ marginTop: '10px' }}>
                  <summary style={summaryStyle}>조회 조건</summary>
                  <div style={{ ...grid, marginTop: '8px' }}>
                    <div style={{ minWidth: 0 }}>
                      <label htmlFor="ic-set-reg-types" style={labelStyle}>판정할 등록구분(쉼표로)</label>
                      <input id="ic-set-reg-types" type="text" value={form.reg_types} disabled={manageOff}
                        onChange={(ev) => setField('reg_types', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }} />
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <label htmlFor="ic-set-exclude-states" style={labelStyle}>뺄 진행상태(쉼표로)</label>
                      <input id="ic-set-exclude-states" type="text" value={form.exclude_states} disabled={manageOff}
                        onChange={(ev) => setField('exclude_states', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }} />
                    </div>
                  </div>
                </details>
              </section>

              <section data-testid="ic-set-plt" aria-labelledby="ic-set-plt-title" style={section}>
                <div style={sectionHead}>
                  <h3 id="ic-set-plt-title" style={sectionTitle}>PLT 환산 기준</h3>
                  {readOnlyManage}
                </div>
                <div data-testid="ic-set-plt-formula" style={formulaBox}>예정수량 ÷ (박스입수 × PLT당 박스수)</div>
                <div style={{ ...mutedLine, marginBottom: '8px' }}>
                  SKU 적재 기준이 있는 상품은 그 기준으로 · 없는(미등록) 상품은 WMS 포장단위 박스입수(없으면 1) × 아래 기본값으로 셉니다
                </div>
                <div style={{ maxWidth: '320px' }}>
                  <label htmlFor="ic-set-boxes" style={labelStyle}>마스터 미등록 SKU 기본값</label>
                  <div style={inlineRow}>
                    <input id="ic-set-boxes" type="text" inputMode="numeric" value={form.default_boxes_per_plt} disabled={manageOff}
                      onChange={(ev) => setField('default_boxes_per_plt', ev.target.value)}
                      style={{ ...fieldInput, width: '90px', ...disabledLook(manageOff) }} />
                    <span style={mutedLine}>박스 / PLT</span>
                  </div>
                </div>
                <fieldset style={fieldsetStyle}>
                  <legend style={legendStyle}>미등록 SKU 처리</legend>
                  {MODE_OPTIONS.map(([value, text]) => (
                    <label key={value} style={radioItem}>
                      <input type="radio" name="ic-set-mode" value={value} checked={form.unregistered_mode === value}
                        disabled={manageOff} onChange={() => setField('unregistered_mode', value)} />
                      {text}
                    </label>
                  ))}
                  <div style={hint}>«별도 목록» = SKU 적재 기준 탭의 미등록 SKU 목록입니다(메신저로 따로 보내지 않습니다)</div>
                </fieldset>
                <div style={{ ...mutedLine, marginTop: '8px' }}>취소·입고완료 요청은 자동 제외 · 요청번호+SKU 기준으로 중복 제거</div>
              </section>
            </>
          )}
        </div>

        <div style={rightCol}>
          {form && (
            <section data-testid="ic-set-targets" aria-labelledby="ic-set-targets-title" style={section}>
              <div style={sectionHead}>
                <h3 id="ic-set-targets-title" style={sectionTitle}>알림 채널</h3>
                {readOnlyManage}
              </div>
              <h4 style={subTitle}>게이트웨이 메신저 채널</h4>
              <div style={{ ...mutedLine, marginBottom: '8px' }}>주의·초과·해제 알림이 이 채널로 갑니다 · 받는 곳이 비면 알림을 보내지 않습니다</div>
              <div style={grid}>
                <div style={{ minWidth: 0 }}>
                  <label htmlFor="ic-set-channel-id" style={labelStyle}>채널 id(또는 채널 이름)</label>
                  <input id="ic-set-channel-id" type="text" value={form.channel_id} disabled={manageOff}
                    onChange={(ev) => setField('channel_id', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <label htmlFor="ic-set-channel-label" style={labelStyle}>채널 이름표</label>
                  <input id="ic-set-channel-label" type="text" maxLength={100} value={form.channel_label} disabled={manageOff}
                    onChange={(ev) => setField('channel_label', ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }} />
                </div>
                {channels?.enabled && (
                  <div style={{ minWidth: 0 }}>
                    <label htmlFor="ic-set-channel-pick" style={labelStyle}>채널 고르기</label>
                    <select id="ic-set-channel-pick" value={channels.items.some((c) => c.id === form.channel_id) ? form.channel_id : ''}
                      disabled={manageOff} onChange={(ev) => pickChannel(ev.target.value)} style={{ ...fieldInput, ...disabledLook(manageOff) }}>
                      <option value="">고르세요</option>
                      {channels.items.map((c) => (
                        <option key={c.id} value={c.id}>{`${c.team ? `${c.team} · ` : ''}${c.name || c.id}${c.type === 'P' ? ' (비공개)' : ''}`}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              {channels?.error && <div style={{ ...alertLine, marginTop: '4px' }}>{channels.error}</div>}
              <div style={actions}>
                <button type="button" onClick={loadChannels} disabled={manageOff} style={{ ...btn('secondary', 'sm'), ...disabledLook(manageOff) }}>↻ 채널 목록</button>
                <button type="button" onClick={clearChannel} disabled={manageOff} style={{ ...btn('secondary', 'sm'), ...disabledLook(manageOff) }}>채널 비우기</button>
              </div>

              <h4 style={{ ...subTitle, marginTop: '14px' }}>초과 시 추가 수신</h4>
              <div style={{ ...mutedLine, marginBottom: '6px' }}>초과 알림만 메신저 DM 으로도 갑니다 — 전 센터 공통 + 그 센터 센터장</div>
              <div style={{ overflowX: 'auto' }}>
                <table aria-label="초과 시 추가 수신" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '320px' }}>
                  <thead><tr>{['센터', '받는 사람', '사람 찾기'].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
                  <tbody>
                    <tr data-testid="ic-set-common-row">
                      <td style={{ ...td, whiteSpace: 'nowrap' }}><b>전 센터 공통</b></td>
                      <td style={td}>{renderPeople(COMMON, form.over_users, 'ic-set-over-user', (u) => `${u.name || `#${u.id}`} 빼기`)}</td>
                      <td style={td}>{renderSearch(COMMON, '전 센터 공통 수신자 찾기')}</td>
                    </tr>
                    {headCenters.map((c) => (
                      <tr key={c.key} data-testid="ic-set-head-row" data-center-key={c.key}>
                        <td style={{ ...td, whiteSpace: 'nowrap' }}>{c.label}</td>
                        <td style={td}>
                          {renderPeople(c.key, form.center_heads[c.key] || [], 'ic-set-head', (u) => `${c.label} ${u.name || `#${u.id}`} 빼기`)}
                        </td>
                        <td style={td}>{renderSearch(c.key, `${c.label} 센터장 찾기`)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {targetsDirty && <div style={{ ...mutedLine, marginTop: '6px' }}>저장하지 않은 받는 곳은 테스트 알림에 쓰지 않습니다 — 먼저 [변경사항 저장]</div>}
            </section>
          )}

          <section data-testid="ic-set-preview" aria-labelledby="ic-set-preview-title" style={section}>
            <div style={sectionHead}>
              <h3 id="ic-set-preview-title" style={sectionTitle}>메시지 미리보기</h3>
              <span style={badge('danger')}>초과 예시</span>
            </div>
            <div style={previewCard}>
              <div data-testid="ic-set-preview-head" style={previewHead}>
                <b>{form?.channel_label || form?.channel_id || '채널 미지정'}</b>
                <span style={mutedLine}>{labels.schedule[form?.schedule] || ''}</span>
              </div>
              {previewLines.map((line, i) => (
                <div key={`line-${i}`} data-testid="ic-set-preview-line" style={i === 0 ? previewTitle : previewLine}>{line}</div>
              ))}
            </div>
          </section>
        </div>
      </div>

      <section data-testid="ic-set-orgs" aria-labelledby="ic-set-orgs-title" style={section}>
        <div style={sectionHead}>
          <h3 id="ic-set-orgs-title" style={sectionTitle}>조직 지정</h3>
          {!canEditOrgs && <div data-testid="ic-set-orgs-readonly" style={mutedLine}>{READONLY_ORGS}</div>}
        </div>
        {orgsMsg && <div role="alert" style={alertLine}>{orgsMsg}</div>}
        <div style={grid}>
          <div style={{ minWidth: 0 }}>
            <label htmlFor="ic-set-view-orgs" style={labelStyle}>전 센터 열람 조직(한 줄에 하나)</label>
            <textarea id="ic-set-view-orgs" rows={3} value={orgForm.view} disabled={orgsOff}
              onChange={(ev) => setOrgForm((cur) => ({ ...cur, view: ev.target.value }))}
              style={{ ...fieldInput, resize: 'vertical', ...disabledLook(orgsOff) }} />
            <div style={{ ...mutedLine, marginTop: '4px' }}>모든 센터를 보기만 합니다(수정 권한은 주지 않습니다)</div>
          </div>
          <div style={{ minWidth: 0 }}>
            <label htmlFor="ic-set-manage-orgs" style={labelStyle}>설정 관리 조직(한 줄에 하나)</label>
            <textarea id="ic-set-manage-orgs" rows={3} value={orgForm.manage} disabled={orgsOff}
              onChange={(ev) => setOrgForm((cur) => ({ ...cur, manage: ev.target.value }))}
              style={{ ...fieldInput, resize: 'vertical', ...disabledLook(orgsOff) }} />
            <div style={{ ...mutedLine, marginTop: '4px' }}>알림 규칙·PLT 환산·받는 곳·SKU 적재 기준을 고칩니다</div>
          </div>
        </div>
        <div style={actions}>
          <button type="button" onClick={saveOrgs} disabled={orgsOff} style={{ ...btn('primary', 'sm'), ...disabledLook(orgsOff) }}>조직 저장</button>
        </div>
        <Msg msg={msgs.orgs} testId="ic-set-orgs-msg" />
      </section>
    </>
  );
}
